import { createContext } from 'react';

export const LanguageContext = createContext<{
  setLocale: (locale: string | null) => void;
  defaultLocale?: string;
  locale: string | null;
} | null>(null);

export default LanguageContext;
